import { render } from "./individual-content.vue?vue&type=template&id=70bd37a6&scoped=true"
import script from "./individual-content.vue?vue&type=script&lang=js"
export * from "./individual-content.vue?vue&type=script&lang=js"

import "./individual-content.vue?vue&type=style&index=0&id=70bd37a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bd37a6"]])

export default __exports__